import React from "react";
import Navbar from "../components/Navbar";
import SiteFooter from "../components/SiteFooter";

const sectionStyle: React.CSSProperties = { marginBottom: 40 };
const h2Style: React.CSSProperties = {
  fontFamily: "Syne, sans-serif",
  fontSize: 18,
  fontWeight: 700,
  color: "#fff",
  marginBottom: 10,
};
const pStyle: React.CSSProperties = {
  fontSize: 14,
  color: "rgba(255,255,255,0.55)",
  lineHeight: 1.8,
};

const TermsPage: React.FC = () => {
  return (
    <div style={{ background: "var(--nx-navy)", minHeight: "100vh" }}>
      <Navbar variant="solid" />

      <section style={{ padding: "160px 5% 100px", maxWidth: 800, margin: "0 auto" }}>
        <span className="nx-badge nx-badge-blue" style={{ marginBottom: 20 }}>
          Legal
        </span>
        <h1
          style={{
            fontFamily: "Syne, sans-serif",
            fontSize: "clamp(26px, 4vw, 40px)",
            fontWeight: 800,
            color: "#fff",
            letterSpacing: "-0.03em",
            marginBottom: 8,
          }}
        >
          Terms of Service
        </h1>
        <p style={{ fontSize: 12, color: "rgba(255,255,255,0.35)", marginBottom: 48 }}>
          Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
        </p>

        <div style={sectionStyle}>
          <h2 style={h2Style}>1. Acceptance of Terms</h2>
          <p style={pStyle}>
            By accessing the Nexora website or platform, operated by Pentagon
            Analytics LLP, you agree to these Terms of Service. If you do not
            agree, please do not use Nexora.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>2. Use of the Service</h2>
          <p style={pStyle}>
            Nexora is provided for lawful residential and community management
            use only. Society admins and staff are responsible for the
            accuracy of data entered on behalf of their community.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>3. Intellectual Property</h2>
          <p style={pStyle}>
            All content, branding, and software associated with Nexora remain
            the property of Pentagon Analytics LLP unless otherwise agreed in
            a separate written contract. © {new Date().getFullYear()} Pentagon
            Analytics LLP. All rights reserved.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>4. Service Availability</h2>
          <p style={pStyle}>
            We aim to keep Nexora available and performant but do not
            guarantee uninterrupted access. Planned maintenance or unforeseen
            issues may occasionally affect availability.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>5. Limitation of Liability</h2>
          <p style={pStyle}>
            Pentagon Analytics LLP is not liable for indirect or consequential
            damages arising from use of Nexora, to the extent permitted by
            applicable law.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>6. Changes to These Terms</h2>
          <p style={pStyle}>
            We may update these terms from time to time. Continued use of
            Nexora after changes constitutes acceptance of the revised terms.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>7. Contact</h2>
          <p style={pStyle}>
            Questions about these terms can be directed to{" "}
            <a href="mailto:nexora@pentagonanalytics.io" style={{ color: "var(--nx-blue-light)" }}>
              nexora@pentagonanalytics.io
            </a>
            .
          </p>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default TermsPage;
